import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { UserlistPhotoComponent } from './userlist-photo.component';
import { DialogComponent} from './dialog/dialog.component';

const routes: Routes = [
    {
        path     : 'userlist-photo',
        component: UserlistPhotoComponent,
        data :{
            permission:{
                only :['role1','role2']
            }
        },
        canActivate:[AuthGuard,RoleGuard]
    }
];

@NgModule({
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        UserlistPhotoComponent,
        DialogComponent
    ],
    entryComponents:[DialogComponent],
    providers:[
        AuthGuard,RoleGuard
    ]
})
export class UserlistPhotoModule
{
}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/userlist-photo/userlist-photo.module.ts